<template>
  <div id="components-modal-demo-position">
    <a-modal
      centered
      :visible="true"
      title="专利365"
      :footer="null"
      @cancel="cancel"
      class="addForm"
    >
      <div class="code-modal">
        <IconWrap
          :width="200"
          :height="200"
          :url="codeUrl"
          class="step-icon"
        ></IconWrap>
        <div class="model-title">
          请用手机扫描二维码，365天，专利信息随时随地触手可及！
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import IconWrap from '@/components/common/IconWrap'
export default {
  props: {},
  data() {
    return {
      Visible: true,
      codeUrl: require('@/assets/images/二维码_肇庆.png')
    }
  },
  components: {
    IconWrap
  },
  mounted() {
    let key = process.env.VUE_APP_KEY
    switch (key) {
      case 'Zq':
        this.codeUrl = require('@/assets/images/二维码_肇庆.png')
        break
      case 'Hy':
        this.codeUrl = require('@/assets/images/二维码_河源.png')
        break
      case 'Mm':
        this.codeUrl = require('@/assets/images/二维码_茂名.png')
        break
      case 'Yj':
        this.codeUrl = require('@/assets/images/二维码_阳江.png')
        break
      case 'Mz':
        this.codeUrl = require('@/assets/images/二维码_梅州.png')
        break
      case 'SzTech':
        this.codeUrl = require('@/assets/images/二维码_深圳科技.png')
        break
      default:
        break
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancelVisible', false)
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped></style>
